import React, { useState } from "react";
import "./couponCard.scss";
import { CircularProgress, IconButton, Stack, Switch } from "@mui/material";
import dateFormat from "dateformat";
import couponStore from "../../stores/couponStore";

// Icon
import ModeEditRoundedIcon from "@mui/icons-material/ModeEditRounded";
import { useNavigate } from "react-router-dom";

const CouponCard = ({ item }) => {
  const CouponStore = couponStore();
  const navigate = useNavigate();
  const [publishLoading, setPublishLoading] = useState(false);

  return (
    <Stack spacing={2} className="single-coupon-card">
      <div className="header-coupon">
        <IconButton
          onClick={async () => {
            await CouponStore.fillUpdateCouponForm({ item });
            navigate(`/coupon/${item._id}/edit`);
          }}
        >
          <ModeEditRoundedIcon className="icon" />
        </IconButton>
        {publishLoading ? (
          <CircularProgress size="22px" sx={{ mr: "17px" }} />
        ) : (
          <Switch
            checked={item.publish}
            onChange={async () => {
              setPublishLoading(true);
              await CouponStore.updateCouponPublish({
                couponID: item._id,
                publish: !item.publish,
              });
              setPublishLoading(false);
            }}
          />
        )}
      </div>
      <div className="content-coupon">
        <Stack spacing={1}>
          <div className="code-name">{item.couponName}</div>
          <div className="code-details">
            <div className="code-sub-description">{item.shortDescription}</div>
            <div className="code-expire-date">
              Expire Date:{" "}
              {dateFormat(new Date(item.validityDate), "mmm dd, yyyy")}
            </div>
          </div>
          <div className="terms-qty-container">
            <div className="code-min-order li">
              <li>Min. order amount is ₹{item.minOrderValue}.</li>
            </div>
            <div className="code-qty li">
              <li>Promo quantity is {item.totalNoOfVoucher}.</li>
            </div>
            <div className="code-qty-used li">
              <li>Used Promo quantity is {item.usedTotalNoOfVoucher}.</li>
            </div>
          </div>
        </Stack>
      </div>
    </Stack>
  );
};

export default CouponCard;
